export const defaultPaymentTerm = "30 days after delivery";
export const defaultDeliveryMethod = "C.I.F  (TO BE ADVICE)"
export const defaultLabelSendTo = "Send To Hong Kong"
export const defaultContactPerson = "Ms. Motosugi / Ms. Usuzawa";
export const deliveryTo = "Musashi Engineering (HK) Ltd."
export const deliveryAttn = "Mr. Ikushima";
export const deliveryPhone = "(852) 26205799";
export const deliveryAddress = "Unit 1706, 17/F., Greenfield Tower, (South) Concordia Plaza,\nNo. 1 Science Museum Road,\nTST East, Kowloon, H.K.";
export const deliveryToSS = "武藏(上海)电子科技有限公司";
export const deliveryAttnSS = "Mr. Ikushima";
export const deliveryPhoneSS = "(86) 21-4467881";
export const deliveryAddressSS = "上海市闵行区合川路3089号\n富群商业大廈B座7楼7A室";
export const sendTo = [{Region: "HK", Label: defaultLabelSendTo}, {Region: "SS", Label: "发到上海"}];
export const defaultEndUser = {name: "Sony Electronics Huanan Co", value: "263"};
export const defaultInvoiceRegions = ["CN", "ID", "HK", "SG", "SS", "TH", "ZZ"];
export const defaultStatementRegions = ["HK", "SS", "ZZ"];
export const defaultPoRegions = ["HK", "SS", "TH", "ZZ"];
export const defaultBankName = "Mizuho Bank,Ltd., Hong Kong Branch";
export const defaultBankNameSS = "瑞穗银行(中国)有限公司";
export const defaultBankNameTH = "Mizuho Bank, Ltd., Bangkok Branch";
export const MonthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];

export const Languages = [
    { id: 1, value: "英語" },
    { id: 2, value: "日本語" },
    { id: 3, value: "中囯語" },
    { id: 4, value: "英/中" },
    { id: 5, value: "英/日" },
    { id: 6, value: "中/日" }
]

export const Categories = [ "MACHINE", "PARTS" ]

export const SubCategories = [
    { category: "PARTS", subCategory: "Syringe Set" }, 
    { category: "PARTS", subCategory: "Needle" }, 
    { category: "PARTS", subCategory: "Multi Nozzle" }, 
    { category: "PARTS", subCategory: "Parts Others" }, 
    { category: "MACHINE", subCategory: "DISPENSER" }, 
    { category: "MACHINE", subCategory: "ROBOT(SM)" }, 
    { category: "MACHINE", subCategory: "ROBOT(S-Mini)" }, 
    { category: "MACHINE", subCategory: "SYSTEM" }, 
    { category: "MACHINE", subCategory: "FAD" }, 
    { category: "MACHINE", subCategory: "ACCESSORY" }, 
    { category: "MACHINE", subCategory: "OTHERS" }
]

export const ProductRegions = [
    { id: 0, value: "Managed By Japan" },
    { id: 1, value: "Managed By Hong Kong" }
]

export function GetCustLangIdsByLanguageId(langId: number)
{
  switch(langId) {
    case 1:
        return [1];
    case 2:
        return [2];
    case 3:
        return [3];
    case 4:
        return [1,3];
    case 5:
        return [1,2];
    case 6:
        return [2,3];
    default:
        return [3];
  }
}

